// value = chave do modelo de guia no backend; label = como o médico lê.
export interface HealthPlan {
  value: string;
  label: string;
}

export const INTERNACAO_PLANS: HealthPlan[] = [
  { value: "AMIL", label: "AMIL" },
  { value: "BRADESCO", label: "BRADESCO" },
  { value: "CAC", label: "CAC" },
  { value: "CASSI", label: "CASSI" },
  { value: "EMBRATEL", label: "EMBRATEL" },
  { value: "EVERCROSS", label: "EVERCROSS" },
  { value: "GAMA", label: "GAMA" },
  { value: "GEAP", label: "GEAP" },
  { value: "GOLDEN_CROSS", label: "GOLDEN CROSS" },
  { value: "INTERMEDICA", label: "INTERMÉDICA" },
  { value: "LEVESAUDE", label: "LEVE SAÚDE" },
  { value: "MUTUA", label: "MÚTUA" },
  { value: "OMINT", label: "OMINT" },
  { value: "PASAVALE", label: "PASA VALE" },
  { value: "PETROBRAS", label: "PETROBRAS" },
  { value: "SULAMERICA", label: "SULAMÉRICA" },
  { value: "UNIMED", label: "UNIMED" },
];

export const OPME_PLANS: HealthPlan[] = [
  { value: "AMIL", label: "AMIL" },
  { value: "BRADESCO", label: "BRADESCO" },
  { value: "LEVESAUDE", label: "LEVE SAÚDE" },
  { value: "PETROBRÁS", label: "PETROBRAS" },
  { value: "SULAMERICA", label: "SULAMÉRICA" },
  { value: "UNIMED", label: "UNIMED" },
];
